<div class="main-view space-y-2 md:space-y-4">
    <app-page-surface-header titleIcon="clock" title="Activities" subtitle="All PD activity across the platform" />

    <app-list-module-surface
        [config]="listSurfaceConfig"
        [filters]="listFilters"
        [errorMessage]="listError"
        [loading]="loading"
        [meta]="meta"
        [rowCount]="rows.length"
        (filtersChange)="onListFiltersChange($event)"
        (pageChange)="onListPageChange($event)"
    >
        <app-activities-table
            listTable
            [rows]="rows"
            [loading]="loading"
            (view)="onView($event)"
        />
    </app-list-module-surface>
</div>
